import * as firebase from "firebase/app";

if (typeof window !== "undefined") {
  firebase.initializeApp({
    apiKey: process.env.GATSBY_FIREBASE_API_KEY,
    authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
    appId: process.env.GATSBY_FIREBASE_APP_ID,
  });
}
